// @ts-nocheck
import React, {
  useState,
  useEffect,
  FunctionComponent,
  useMemo,
  ReactElement,
} from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux'
import { getSpotifyToken } from 'Redux/selectors/spotifyToken'
import { createRelaunchCampaign } from 'Redux/actions/campaignActions'
import { createCampaign, campaignsList } from 'Router/routes'
import { sendScheduleStartEvent } from 'Redux/actions/googleAnalyticsActions'
import { campaignScheduleStartEvent } from 'Helpers/tagManager'
import { APP } from 'Configs/App'
import { updateScheduledCampaign } from 'Redux/actions/scheduleActions'
import { getCampaigns } from 'Redux/selectors/campaigns'
import { getIsEmailBounced, getIsAuth } from 'Redux/selectors/auth'
import { CampaignStatus } from 'Constants/enums'
import { activeTabStorage } from 'Constants/constants'
import { Mobile, Desktop } from 'Shared/components/Responsive'
import CampaignCard from '../CampaignCard'
import ApprovedCampaignAlert from '../ApprovedCampaignAlert'
import EmailNotConfirmedAlert from '../EmailNotConfirmedAlert'
import RenewCampaignAlert from '../RenewCampaignAlert'
import ActionsBlock from '../ActionsBlock'

import {
  Card,
  StyledList,
  StyledNoData,
  TabName,
  Number,
  StyledTabs,
  StyledTabsItem,
  StyledTabsWrapper,
} from './styles'

const CampaignsList: FunctionComponent = (): ReactElement => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const spotifyAccessToken: string = useSelector(getSpotifyToken)
  const campaigns = useSelector(getCampaigns)
  const isEmailBounced: boolean = useSelector(getIsEmailBounced)

  const [allCampaigns, updateAllCampaigns] = useState([])
  const [activeSearch, setActiveSearch] = useState(false)
  const [activeTab, setActiveTab] = useState('1')

  const isEmailConfirmed: boolean = useSelector(
    (state: RootStateOrAny) => state.auth.user.is_email_confirmed
  )
  const isFirstCampaign: boolean = useSelector(
    (state: RootStateOrAny) => state.auth.user.is_first_campaign
  )
  const email: string = useSelector(
    (state: RootStateOrAny) => state.auth.user.email
  )
  const auth = useSelector(getIsAuth)

  const campaignToRelaunchFromAlert = useMemo(
    () =>
      campaigns.find(
        campaign => campaign.status === 'ended' && campaign.relaunched === false
      ),
    [campaigns]
  )

  const handleFindCampaign = (str: string) => {
    const searchString = str.toLowerCase()
    updateAllCampaigns(
      campaigns.filter(
        i =>
          i.trackTitle.toLowerCase().indexOf(searchString) !== -1 ||
          i.trackAuthorName.toLowerCase().indexOf(searchString) !== -1
      )
    )
  }

  const handleRelaunchCampaign = (campaign_id: number | string): void => {
    const url = window.location.href

    dispatch(
      createRelaunchCampaign(campaign_id, url, (error, res) => {
        if (!error) {
          dispatch(updateScheduledCampaign(res))

          campaignScheduleStartEvent(
            res.type,
            res?.Track?.TrackGenres?.map(el => el.Genre.genre_name).join(),
            res?.Track?.TrackLanguages?.map(
              el => el.Language.language_name
            ).join(),
            res.id,
            CampaignPlatformTypeEnum.SPOTIFY,
            user.id,
            amountOfCampaigns,
            res?.is_feed || false
          )
          history.push(`/campaigns/schedule/${res.id}`)
        }
        // TODO catch err
      })
    )
  }

  const checkAccessToken = () => {
    if (auth || spotifyAccessToken) {
      history.push(`${campaignsList}${createCampaign}`)
    } else {
      window.location.href = APP.SPOTIFY_AUTH_API
    }
  }

  const approvedAlerts =
    campaigns?.find(({ status }) => status === 'approved') &&
    campaigns
      .filter(
        ({ status, trackTitle }) =>
          status === 'approved' &&
          !campaigns
            .filter(
              ({ status: companyStatus }) => companyStatus === 'scheduled'
            )
            .find(
              ({ trackTitle: new_track_name }) => trackTitle === new_track_name
            )
      )
      .slice(0, 1)
      .map(campaign => (
        <ApprovedCampaignAlert
          // @ts-ignore
          campaign={campaign}
          history={history}
          key={campaign.id}
          updateScheduledCampaign={updateScheduledCampaign}
        />
      ))

  const emailConfirmation = ((!isEmailConfirmed && !isFirstCampaign) ||
    isEmailBounced) && (
    <EmailNotConfirmedAlert email={email} isEmailBounced={isEmailBounced} />
  )

  const relaunchAlert = campaignToRelaunchFromAlert && (
    <RenewCampaignAlert
      campaign={campaignToRelaunchFromAlert}
      history={history}
      key={campaignToRelaunchFromAlert.id}
      activeTab={activeTab}
      updateScheduledCampaign={handleRelaunchCampaign}
    />
  )

  const allCampaignsList = allCampaigns?.map(campaign => (
    <CampaignCard campaign={campaign} key={campaign.id} activeTab={activeTab} />
  ))

  const allCampaignsListLenght = allCampaignsList?.length

  const pendingApprovalList = allCampaigns
    ?.filter(
      ({ status }) =>
        status === CampaignStatus.PENDING_APPROVAL ||
        status === CampaignStatus.AWAITING_REVIEW
    )
    .map(campaign => (
      <CampaignCard
        campaign={campaign}
        key={campaign.id}
        activeTab={activeTab}
      />
    ))

  const pendingApprovalListLenght = pendingApprovalList?.length

  const approvedList = allCampaigns
    ?.filter(
      ({ status }) =>
        status === CampaignStatus.APPROVED || status === CampaignStatus.PENDING
    )
    .map(campaign => (
      <CampaignCard
        campaign={campaign}
        key={campaign.id}
        activeTab={activeTab}
      />
    ))

  const approvedListLenght = useMemo(
    () =>
      campaigns?.filter(
        ({ status }) =>
          status === CampaignStatus.APPROVED ||
          status === CampaignStatus.PENDING
      )?.length,
    [campaigns]
  )

  const runningList = allCampaigns
    ?.filter(
      ({ status }) =>
        status === CampaignStatus.RUNNING || status === CampaignStatus.INPROCESS
    )
    .map(campaign => (
      <CampaignCard
        campaign={campaign}
        key={campaign.id}
        activeTab={activeTab}
      />
    ))

  const runningListLenght = runningList?.length

  const finishedList = allCampaigns
    ?.filter(
      ({ status }) =>
        status === CampaignStatus.ENDED || status === CampaignStatus.FINISHED
    )
    .map(campaign => (
      <CampaignCard
        campaign={campaign}
        key={campaign.id}
        activeTab={activeTab}
      />
    ))

  const finishedListLenght = finishedList?.length

  const stoppedList = allCampaigns
    ?.filter(({ status }) => status === CampaignStatus.STOPPED)
    .map(campaign => (
      <CampaignCard
        campaign={campaign}
        key={campaign.id}
        activeTab={activeTab}
      />
    ))

  const stoppedListLenght = stoppedList?.length

  useEffect(() => {
    const prevActiveTab = window.sessionStorage.getItem(activeTabStorage)
    prevActiveTab && setActiveTab(prevActiveTab)
  }, [])

  useEffect(() => {
    updateAllCampaigns(campaigns)
  }, [campaigns])

  return (
    <>
      {approvedAlerts}

      {emailConfirmation}

      {relaunchAlert}

      <Card>
        <Desktop>
          <ActionsBlock
            approvedListLenght={approvedListLenght}
            checkAccessToken={checkAccessToken}
            activeSearch={activeSearch}
            setActiveSearch={setActiveSearch}
            handleFindCampaign={handleFindCampaign}
          />
        </Desktop>
        <StyledTabsWrapper>
          <StyledTabs
            defaultActiveKey="1"
            activeKey={activeTab}
            onChange={value => setActiveTab(value)}
          >
            <StyledTabsItem
              tab={
                <>
                  <TabName>{t('campaignResultsPage.all')}</TabName>
                  <Number>{allCampaignsListLenght}</Number>
                </>
              }
              key="1"
            >
              <Mobile>
                <ActionsBlock
                  approvedListLenght={approvedListLenght}
                  checkAccessToken={checkAccessToken}
                  activeSearch={activeSearch}
                  setActiveSearch={setActiveSearch}
                  handleFindCampaign={handleFindCampaign}
                />
              </Mobile>
              {allCampaignsList.length > 0 ? (
                <StyledList>{allCampaignsList}</StyledList>
              ) : (
                <StyledNoData>No data available</StyledNoData>
              )}
            </StyledTabsItem>

            <StyledTabsItem
              tab={
                <>
                  <TabName>{t('campaignsPage.pendingApproval')}</TabName>
                  <Number>{pendingApprovalListLenght}</Number>
                </>
              }
              key="2"
            >
              <Mobile>
                <ActionsBlock
                  approvedListLenght={approvedListLenght}
                  checkAccessToken={checkAccessToken}
                  activeSearch={activeSearch}
                  setActiveSearch={setActiveSearch}
                  handleFindCampaign={handleFindCampaign}
                />
              </Mobile>

              {pendingApprovalList.length > 0 ? (
                <StyledList>{pendingApprovalList}</StyledList>
              ) : (
                <StyledNoData>No data available</StyledNoData>
              )}
            </StyledTabsItem>

            <StyledTabsItem
              tab={
                <>
                  <TabName>{t('campaignsPage.approved')}</TabName>
                  <Number approved>{approvedListLenght}</Number>
                </>
              }
              key="3"
            >
              <Mobile>
                <ActionsBlock
                  approvedListLenght={approvedListLenght}
                  checkAccessToken={checkAccessToken}
                  activeSearch={activeSearch}
                  setActiveSearch={setActiveSearch}
                  handleFindCampaign={handleFindCampaign}
                />
              </Mobile>

              {approvedList.length > 0 ? (
                <StyledList>{approvedList}</StyledList>
              ) : (
                <StyledNoData>No data available</StyledNoData>
              )}
            </StyledTabsItem>

            <StyledTabsItem
              tab={
                <>
                  <TabName>{t('campaignsPage.running')}</TabName>
                  <Number>{runningListLenght}</Number>
                </>
              }
              key="4"
            >
              <Mobile>
                <ActionsBlock
                  approvedListLenght={approvedListLenght}
                  checkAccessToken={checkAccessToken}
                  activeSearch={activeSearch}
                  setActiveSearch={setActiveSearch}
                  handleFindCampaign={handleFindCampaign}
                />
              </Mobile>

              {runningList.length > 0 ? (
                <StyledList>{runningList}</StyledList>
              ) : (
                <StyledNoData>No data available</StyledNoData>
              )}
            </StyledTabsItem>

            <StyledTabsItem
              tab={
                <>
                  <TabName>{t('campaignsPage.finished')}</TabName>
                  <Number>{finishedListLenght}</Number>
                </>
              }
              key="5"
            >
              <Mobile>
                <ActionsBlock
                  approvedListLenght={approvedListLenght}
                  checkAccessToken={checkAccessToken}
                  activeSearch={activeSearch}
                  setActiveSearch={setActiveSearch}
                  handleFindCampaign={handleFindCampaign}
                />
              </Mobile>

              {finishedList.length > 0 ? (
                <StyledList>{finishedList}</StyledList>
              ) : (
                <StyledNoData>No data available</StyledNoData>
              )}
            </StyledTabsItem>

            <StyledTabsItem
              tab={
                <>
                  <TabName>{t('campaignsPage.stopped')}</TabName>
                  <Number>{stoppedListLenght}</Number>
                </>
              }
              key="6"
            >
              <Mobile>
                <ActionsBlock
                  approvedListLenght={approvedListLenght}
                  checkAccessToken={checkAccessToken}
                  activeSearch={activeSearch}
                  setActiveSearch={setActiveSearch}
                  handleFindCampaign={handleFindCampaign}
                />
              </Mobile>

              {stoppedList.length > 0 ? (
                <StyledList>{stoppedList}</StyledList>
              ) : (
                <StyledNoData>No data available</StyledNoData>
              )}
            </StyledTabsItem>
          </StyledTabs>
        </StyledTabsWrapper>
      </Card>
    </>
  )
}

export default CampaignsList
